export default {
    styleOverrides: {
        root: {
            borderRadius: 8,
        },
    },
}